import {
  observeTeaserElement,
  observeImpressionElement,
  startObservingImpressionElements,
  startObservingTeaserElements,
  unobserveTeaserElement,
  unobserveImpressionElement,
} from "./impression-tracker";
import dataLayerApi from "./dataLayerApi";
import {
  registerGlobalClickTracker,
  unregisterGlobalClickTracker,
} from "./global-click-tracker";
import { ignoreTextOfElementsWith } from "./get-data-from-entry";

export const version = __PACKAGE_VERSION__;

export function scanForElementsToTrack() {
  startObservingTeaserElements();
  startObservingImpressionElements();
  unregisterGlobalClickTracker();
  registerGlobalClickTracker();
}

export {
  dataLayerApi,
  observeTeaserElement,
  unobserveTeaserElement,
  observeImpressionElement,
  unobserveImpressionElement,
  ignoreTextOfElementsWith,
};
